/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Reservation_DepositInputs */

const cs_enum_reservation_deposit = /** @type {(inputs: Enum_Reservation_DepositInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervační záloha`)
};

const en_enum_reservation_deposit = /** @type {(inputs: Enum_Reservation_DepositInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservation deposit`)
};

/**
* | output |
* | --- |
* | "Reservation deposit" |
*
* @param {Enum_Reservation_DepositInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_reservation_deposit = /** @type {((inputs?: Enum_Reservation_DepositInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Reservation_DepositInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_reservation_deposit(inputs)
	return cs_enum_reservation_deposit(inputs)
});